import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { SignContractModal } from '.';
import { contractTypeT } from '../enums';

@translate()
export default class SignLoanModal extends Component {
  static propTypes = {
    modalActions: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    fileLocation: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  };

  render() {
    const {
      onSubmit,
      isLoading,
      modalActions,
      fileLocation,
      t,
    } = this.props;

    let modalText = t(
      'Dlžník sa oboznámil so znením Zmluvy o poistení (zmluva medzi Vami a prevádzkovateľom portálu Majak.sk, spoločnosť Peer2Peer, s.r.o.), rozumie jej, súhlasí s jej znením a berie na vedomie všetky jej účinky ako aj všetky práva a povinnosti z nej vyplývajúce. Je si vedomý, že kliknutím na tlačidlo “Potvrdiť Zmluvu o poistení” je táto zmluva pre dlžníka v celom svojom rozsahu záväzná.'
    )
    let checkBoxText = t('Súhlasím so Zmluvou o poistení')
    let buttonText = t('Potvrdiť Zmluvu o positení')


    return (
      <SignContractModal
        hideModal={modalActions.hide}
        isLoading={isLoading}
        onSubmit={onSubmit}
        fileLocation={fileLocation}
        title={contractTypeT.INSURANCE_CONTRACT}
        text={modalText}
        checkboxText={checkBoxText}
        buttonText={buttonText}
        fileLinktext={t('Prečítať zmluvu')}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/modals/SignLoanInsuranceModal.js